"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogger = exports.inlineLoggerReady = exports.initializeClientSideInlineLogger = void 0;
const client_api_1 = require("./inliner/client-api");
Object.defineProperty(exports, "initializeClientSideInlineLogger", { enumerable: true, get: function () { return client_api_1.initializeClientSideInlineLogger; } });
Object.defineProperty(exports, "inlineLoggerReady", { enumerable: true, get: function () { return client_api_1.inlineLoggerReady; } });
Object.defineProperty(exports, "getLogger", { enumerable: true, get: function () { return client_api_1.getLogger; } });
